import React, { useCallback, useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomDataTable from "../../components/CustomDataTable";
import CustomDropdown from "../../components/CustomDropdown";
import Hoc from "../../components/HOC";
import Loader from "../../components/Loader";
import CustomToolTip from "../../components/ToolTip";
import { FcApproval, FcCancel } from "react-icons/fc";
import moment from "moment";
import TextInput from "../../components/TextInput";
import {
  MdCancel,
  MdDownload,
  MdEditDocument,
  MdInfo,
  MdPageview,
  MdViewList,
  MdAttachFile,
  MdVisibility,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown
} from "react-icons/md";
import ModalComponent from "../../components/Modal";
import { CalendarToday, InsertDriveFile } from "@mui/icons-material";
import MuiDatePicker from "../../components/MuiDatePicker";
import {
  requestDownloadInvoiceAction,
  requestDownloadTimeSheetAction,
  requestGenerateInvoice,
  requestTimesheetById,
  requestTimesheetListAction,
  requestTimesheetsAction,
  setResetGenerateInvoice,
  setResetStatedownloadInvoice,
  setResetStatedownloadTimeSheet,
  setResetStateTimesheetById,
  setResetTimesheetsAction,
  setResetDownloadFileById,
} from "../../Redux/TimeSheetState/TimeSheetActionCreator";
import { requestUsersListActionWithOutPagination, setResetStateUsersListWithOutPagination } from "../../Redux/UserState/UserActionCreator";
import { requestProjectsById, setResetStateProjectsById } from "../../Redux/ProjectState/ProjectActionCreator";
import { requestDownloadFileAction } from "../../Redux/FileState/uploadFileActionCreator";
import { requestDownloadFileById } from "../../Redux/TimeSheetState/TimeSheetActionCreator";

const validationSchema = Yup.object({
  employee: Yup.string().required("Employee is required"),
  project: Yup.string().required("Project is required"),
});

const AdminTimesheet = () => {
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [modalOpen, setModalOpen] = useState({ open: false, id: null });
  const [ratePerHour, setRatePerHour] = useState("");
  const [reason, setReason] = useState("");
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [pendingEmployeeId, setPendingEmployeeId] = useState(null); // Track employee for prefill
  const [sortBy, setSortBy] = useState('desc');
  const formikRef = useRef();
  const usersList = useSelector((state) => state.UsersListWithOutPagination);
  const projectsList = useSelector((state) => state.ProjectsByIdReducer);
  const TimeSheets = useSelector((state) => state.TimeSheetByProjectIdReducer);
  const TimesheetAction = useSelector((state) => state.TimesheetsActionReducer);
  const GenerateInvoiceReducer = useSelector(
    (state) => state.GenerateInvoiceReducer
  );
  const DownloadInvoiceReducer = useSelector(
    (state) => state.DownloadInvoiceReducer
  );

  const DownloadTimeSheetReducer = useSelector(
    (state) => state.DownloadTimeSheetReducer
  );

  const DownloadFileByIdReducer = useSelector(
    (state) => state.DownloadFileByIdReducer
  );

  const handleCheckboxChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleinvoice = () => {
    if (selectedRows.length === 0) {
      toast.error("No timesheets selected for invoicing.");
    } else {
      const payload = {
        timesheetIds: selectedRows.map((row) => row.id),
        ratePerHour: 0,
      };
      dispatch(requestGenerateInvoice(payload));
      setClearSelectedRows(true);
    }
    dispatch(setResetTimesheetsAction());
  };

  const rowDisabledCriteria = (row) => row.status !== "APP" || row.invoiceGenerated !== null;
  const handleEndDateSort = () => {
    const newSortBy = sortBy === 'desc' ? 'asce' : 'desc';
    setSortBy(newSortBy);
  };

  const columns = [
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate).format("MM-DD-YYYY"),
      
    },
    {
      name: (
        <div className="flex items-center gap-2 cursor-pointer" onClick={handleEndDateSort}>
          <span>End Date</span>
          {sortBy === 'desc' ? (
            <MdKeyboardArrowUp className="w-4 h-4 text-black-600" />
          ) : sortBy === 'asce' ? (
            <MdKeyboardArrowDown className="w-4 h-4 text-black-600" />
          ) : (
            <MdKeyboardArrowDown className="w-4 h-4 text-gray-400" />
          )}
        </div>
      ),
      selector: (row) => moment(row.endDate).format("MM-DD-YYYY"),
      
    },
    { name: "Location", selector: (row) => row.work_location, sortable: false },
    { name: "Total Hours", selector: (row) => row.total_hours, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-4">
          {(row.status === "RESUB" || row.status === "SUB") && (
            <>
              <button
                onClick={() => handleApprove(row)}
                className="text-black hover:text-black"
              >
                <FcApproval size={24} data-tip data-for="registerTip" />
                <CustomToolTip id="registerTip" title="Approve" />
              </button>
              <button
                onClick={() => handleReject(row)}
                className="text-black hover:text-black"
              >
                <MdCancel size={24} data-tip data-for="rejected" />
                <CustomToolTip id="rejected" title="Reject" />
              </button>
            </>
          )}
          {row.status === "APP" && (
            <>
              <FcApproval size={24} fill="green" data-tip data-for="approved" />
              <CustomToolTip id="approved" title="Approved" />
            </>
          )}
          {row.status === "REJ" && (
            <>
              <MdCancel size={24} fill="red" data-tip data-for="rejected" />
            </>
          )}
          <button
            onClick={() => handleView(row)}
            className="text-primary hover:text-primaryDark"
          >
            <>
              <MdVisibility size={24} data-tip data-for="View" />
              <CustomToolTip id="View" title="Details" />
            </>
          </button>
          {/* {row.invoiceGenerated && (
            <button
              onClick={() => handleDownload(row)}
              className="text-primary hover:text-blue-700 disabled:cursor-not-allowed"
            >
              <>
                <MdDownload size={24} data-tip data-for="invoiceGenerated" />
                <CustomToolTip id="invoiceGenerated" title="Download Invoice" />
              </>
            </button>
          )} */}
        </div>
      ),
    },
  ];

 

  const conditionalRowStyles = [
    {
      when: (row) => row.status === "APP",
      style: {
        backgroundColor: "#E0FFE0",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#E0FFE0",
          color: "#black",
        },
      },
    },
    {
      when: (row) => row.status === "REJ",
      style: {
        backgroundColor: "#FF85A2",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#FF85A2",
          color: "#black",
        },
      },
    },
  ];

  const handleApprove = (row) => {
    dispatch(requestTimesheetsAction({ id: row.id, action: "approve" }));
    toast.success("Timesheet approved successfully");
    dispatch(requestTimesheetListAction({ status: "SUB", page: 0, size: 10, sortby: sortBy }));
  };

  const handleReject = (row) => {
    setModalOpen({ open: true, id: row.id });
    // toast.error("Timesheet rejected.");
    dispatch(requestTimesheetListAction({ status: "SUB", page: 0, size: 10, sortby: sortBy }));
  };

  const handlePageChange = (page) => {
    dispatch(
      requestTimesheetById({
        employee: TimeSheets?.employee,
        project: TimeSheets?.project,
        fromDate: TimeSheets?.fromDate,
        size: TimeSheets?.size,
        page: page,
        sortby: sortBy,
        employeeName: TimeSheets?.employeeName,
        projectName: TimeSheets?.projectName,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(
      requestTimesheetById({
        employee: TimeSheets?.employee,
        project: TimeSheets?.project,
        fromDate: TimeSheets?.fromDate,
        size: size,
        page: 0,
        sortby: sortBy,
        employeeName: TimeSheets?.employeeName,
        projectName: TimeSheets?.projectName,
      })
    );
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setIsModalOpenView(true);
  };

  // const handleConfirm = () => {
  //   if (!ratePerHour || selectedRows.length === 0) {
  //     toast.error("Please enter a valid rate and select timesheets.");
  //     return;
  //   }
  //   const payload = {
  //     timesheetIds: selectedRows.map((row) => row.id),
  //     ratePerHour: 0,
  //   };

  //   dispatch(requestGenerateInvoice(payload));
  //   setIsModalOpen(false);
  //   setRatePerHour("");
  //   setClearSelectedRows(true);
  // };

  const handleConfirmReject = (id) => {
    if (!reason.trim()) {
      toast.error("Please provide a reason for rejection.");
      return;
    }
    dispatch(
      requestTimesheetsAction({
        id,
        action: "reject",
        remarks: reason,
      })
    );

    toast.success("Timesheet has rejected.");
    dispatch(setResetTimesheetsAction());
    setModalOpen({ open: false, id: null });
    setReason("");
  };

  const handleDownload = (row) => {
    dispatch(
      requestDownloadInvoiceAction({
        id: row.userId,
        invoiceId: row.invoiceGenerated,
      })
    );
  };

  const handleDownloadTimesheet = (fileId) => {
    dispatch(requestDownloadTimeSheetAction(fileId));
  };

  const downloadFile = (fileId) => {
    dispatch(requestDownloadFileById({tId:selectedRow.id,fileId:fileId}));
  };

  useEffect(() => {
    dispatch(requestUsersListActionWithOutPagination("USER"));
    dispatch(setResetStateTimesheetById());
    dispatch(setResetStateProjectsById());
  }, []);

  useEffect(() => {
    if (TimeSheets?.error && !TimeSheets?.loading) {
      toast.error(TimeSheets?.error?.message);
      dispatch(setResetStateTimesheetById());
      dispatch(setResetGenerateInvoice());
    }
  }, [TimeSheets]);

  useEffect(() => {
    if (TimesheetAction?.response && !TimesheetAction?.loading) {
      dispatch(
        requestTimesheetById({
          employee: TimeSheets?.employee,
          project: TimeSheets?.project,
          fromDate: TimeSheets?.fromDate,
          size: TimeSheets?.size,
          page: TimeSheets?.page,
          employeeName: TimeSheets.employeeName,
          projectName: TimeSheets.projectName,
          sortby: sortBy
        })
      );
      dispatch(setResetTimesheetsAction());
    }
    if (TimesheetAction?.error && !TimesheetAction?.loading) {
      toast.error("Something went wrong");
      dispatch(setResetTimesheetsAction());
    }
  }, [TimesheetAction]);
  



  

  useEffect(() => {
    if (DownloadInvoiceReducer?.error && !DownloadInvoiceReducer?.loading) {
      toast.error("something went wrong");
      dispatch(setResetStatedownloadInvoice());
    }
  }, [DownloadInvoiceReducer]);

  useEffect(() => {
    if (DownloadTimeSheetReducer?.error && !DownloadTimeSheetReducer?.loading) {
      toast.error("something went wrong");
      dispatch(setResetStatedownloadTimeSheet());
    }
  }, [DownloadTimeSheetReducer]);

  useEffect(() => {
    if (GenerateInvoiceReducer?.response && !GenerateInvoiceReducer?.loading) {
      toast.success("Invoice successfully generated!");
      dispatch(setResetGenerateInvoice());
      dispatch(
        requestTimesheetById({
          employee: TimeSheets?.employee,
          project: TimeSheets?.project,
          fromDate: TimeSheets?.fromDate,
          size: TimeSheets?.size,
          page: TimeSheets?.page,
          employeeName: TimeSheets?.employeeName,
          projectName: TimeSheets.projectName,
          sortby: sortBy
        })
      );
    }
    if (GenerateInvoiceReducer?.error && !GenerateInvoiceReducer?.loading) {
      toast.error("something went wrong");
      dispatch(setResetGenerateInvoice());
    }
  }, [GenerateInvoiceReducer]);

  useEffect(() => {
    if (clearSelectedRows) {
      setSelectedRows([]);
      setClearSelectedRows(false);
    }
  }, [clearSelectedRows]);

  // // Prefill first project when projectsList updates
  // useEffect(() => {
  //   if (projectsList?.response?.length > 0 && pendingEmployeeId) {
  //     const firstProjectId = projectsList.response[0].id;
  //     // Update Formik field via a ref or dispatch (handled in handleChange)
  //     setPendingEmployeeId(null); // Clear pending state
  //   }
  // }, [projectsList, pendingEmployeeId]);

  useEffect(() => {
    if (
      selectedEmployeeId &&
      projectsList?.response &&
      projectsList.response.length > 0
    ) {
      formikRef.current?.setFieldValue("project", projectsList.response[0].id);
      formikRef.current?.setFieldValue("projectName", projectsList.response[0].projectName);
    }
  },[projectsList, selectedEmployeeId]);

  useEffect(() => {
    if (DownloadFileByIdReducer?.error && !DownloadFileByIdReducer?.loading) {
      toast.error(DownloadFileByIdReducer?.error?.message || "Failed to download file. Please try again.");
      dispatch(setResetDownloadFileById());
    }
  }, [DownloadFileByIdReducer]);

  useEffect(() => {
    if (DownloadFileByIdReducer?.response && !DownloadFileByIdReducer?.loading) {
      toast.success("File downloaded successfully!");
      dispatch(setResetDownloadFileById());
    }
  }, [DownloadFileByIdReducer]);

  // Watch for sort changes and trigger API call
  useEffect(() => {
    // Only trigger API call if we have data and sortBy is not null (user has clicked sort)
    if (TimeSheets?.employee && TimeSheets?.project && sortBy !== null && TimeSheets?.response) {
      dispatch(
        requestTimesheetById({
          employee: TimeSheets.employee,
          project: TimeSheets.project,
          fromDate: TimeSheets.fromDate,
          size: TimeSheets.size,
          page: TimeSheets.page, // Keep current page when sorting changes
          employeeName: TimeSheets.employeeName,
          projectName: TimeSheets.projectName,
          sortby: sortBy
        })
      );
    }
  }, [sortBy]);
  
  const DetailsModal = ({ isOpen, onClose, data, onDownload, isDownloading }) => {
    if (!isOpen || !data) return null;
    

    // Use Formik for the modal form
    return (
      <Formik
        initialValues={{
          projectName: TimeSheets.projectName || '',
          employeeName: TimeSheets.employeeName || '',
          workLocation: data?.work_location || '',
          status: data?.status || '',
          startDate: data?.startDate ? moment(data.startDate).format("MM-DD-YYYY") : '',
          endDate: data?.endDate ? moment(data.endDate).format("MM-DD-YYYY") : '',
          totalHours: data?.total_hours || '',
          remarks: data?.remarks || '',
        }}
        enableReinitialize
        onSubmit={() => {}} // No submit action, just for display
      >
        {({ values }) => (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-0 rounded-2xl shadow-2xl w-11/12 md:w-3/4 lg:w-2/4 relative z-50 max-h-[calc(100vh-0.5rem)] border border-gray-200">
              <div className="overflow-y-auto" style={{ maxHeight: '90vh' }}>
                {/* Modal Header */}
                <div className="sticky top-0 bg-white z-10 border-b border-gray-200 flex items-center justify-between px-6 py-4 gap-4 rounded-t-2xl">
                  <div className="flex items-center gap-3">
                    <h2 className="text-primary text-2xl font-bold tracking-tight">Timesheet Details</h2>
                  </div>
                  <button
                    onClick={onClose}
                    className="text-primary hover:text-primaryDark transition-colors p-2 rounded-full focus:outline-none absolute top-4 right-4"
                    type="button"
                    aria-label="Close"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <Form>
                  <div className="flex flex-col gap-6 mb-4 px-8 pt-6 pb-2">
                    {/* Row 1 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.projectName}
                          name="projectName"
                          legend
                          isDisabled
                          placeholder="Project Name"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.employeeName}
                          name="employeeName"
                          legend
                          isDisabled
                          placeholder="Employee Name"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Row 2 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.workLocation}
                          name="workLocation"
                          legend
                          isDisabled
                          placeholder="Work Location"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.status}
                          name="status"
                          legend
                          isDisabled
                          placeholder="Status"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Row 3 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.startDate}
                          name="startDate"
                          legend
                          isDisabled
                          placeholder="Start Date"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.endDate}
                          name="endDate"
                          legend
                          isDisabled
                          placeholder="End Date"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.totalHours}
                          name="totalHours"
                          legend
                          isDisabled
                          placeholder="Total Hours"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Rejection Reason */}
                    {values.status === 'REJ' && values.remarks && (
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.remarks}
                          name="remarks"
                          legend
                          isDisabled
                          placeholder="Rejection Reason"
                          customClasses="bg-red-50 text-rose-600 border-rose-200"
                        />
                      </div>
                    )}
                  </div>
                </Form>

                {/* Section Divider */}
                <div className="px-6">
                  <div className="border-t border-dashed border-gray-200" />
                </div>

                {/* Holidays & Attachments Section */}
                <div className="px-6 py-2">
                  <h2 className="text-primary text-lg font-semibold flex items-center">
                    <CalendarToday className="text-primary/70" fontSize="small" /> Holidays & Attachments
                  </h2>

                  {/* Holidays Section */}
                  <div className="my-2">
                    <div className="space-y-3">
                      {data.holidays?.length > 0 ? (
                        data.holidays.map((holiday, idx) => (
                          <div
                            key={holiday.id || idx}
                            className="p-3 border border-gray-100 rounded-lg bg-gray-50 shadow-sm flex flex-col sm:flex-row gap-2 sm:gap-4"
                          >
                            <div className="w-full">
                              <label className="block text-xs text-gray-500 mb-1 font-medium">Holiday Date</label>
                              <div className="bg-white px-3 py-2 rounded text-sm border border-gray-100">
                                {holiday.employee_holiday_date ? moment(holiday.employee_holiday_date).format("MM-DD-YYYY") : "-"}
                              </div>
                            </div>
                            <div className="w-full">
                              <label className="block text-xs text-gray-500 mb-1 font-medium">Notes</label>
                              <div className="bg-white px-3 py-2 rounded text-sm border border-gray-100">{holiday.notes || "-"}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-4 bg-gray-50 rounded-lg border border-dashed border-gray-200 flex items-center justify-center">
                          <p className="text-gray-400 text-xs sm:text-sm">
                            No holidays in this timesheet.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Attachments Section */}
                  <div className="my-2">
                    <h2 className="text-primary text-lg font-semibold flex items-center">
                      <MdAttachFile size={20} /> Attachments
                      </h2>
                    <div className="space-y-3 max-h-40 overflow-y-scroll noScrollBarWidth">
                      {data.files?.length > 0 ? (
                        data.files.map((file) => (
                          <div
                            key={file.id}
                            className="flex items-center justify-between p-3 border border-gray-100 rounded-lg bg-gray-50 shadow-sm"
                          >
                            <div className="flex-1 truncate">
                              <span className="text-gray-700 text-sm font-medium">{file.fileName}</span>
                            </div>
                            <MdDownload
                              className={`cursor-pointer w-6 h-6 ml-2 transition-colors duration-150 ${isDownloading
                                ? 'text-gray-400 animate-pulse'
                                : 'text-green-600 hover:text-green-700 hover:scale-110'
                              }`}
                              onClick={() => !isDownloading && onDownload(file.id)}
                              data-tip
                              data-for={`download-${file.id}`}
                            />
                            <CustomToolTip
                              id={`download-${file.id}`}
                              title={isDownloading ? "Downloading..." : "Download File"}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-4 bg-gray-50 rounded-lg border border-dashed border-gray-200 flex items-center justify-center">
                          <p className="text-gray-400 text-xs sm:text-sm">
                            No files available.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik>
    );
  };

  // Cleanup function to reset all states when component unmounts
  useEffect(() => {
    return () => {
      
      
      // Reset all Redux states
      dispatch(setResetStateTimesheetById());
      dispatch(setResetStateProjectsById());
      dispatch(setResetStateUsersListWithOutPagination());
      dispatch(setResetTimesheetsAction());
      dispatch(setResetGenerateInvoice());
      dispatch(setResetStatedownloadInvoice());
      dispatch(setResetStatedownloadTimeSheet());
      dispatch(setResetDownloadFileById());
    };
  }, [dispatch]);

  return (
    <div className="w-full p-6">
      <Loader
        isLoading={TimesheetAction.loading || TimeSheets.loading || usersList.loading || DownloadFileByIdReducer?.loading}
      />
      <Formik
      innerRef={formikRef}
        initialValues={{
          employee: "",
          project: "",
          fromDate: "",
          employeeName:"",
          projectName:""
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          dispatch(setResetStateTimesheetById());
          // Reset sort state when performing a new search
          setSortBy('desc');
          dispatch(
            requestTimesheetById({
              employee: values.employee,
              project: values.project,
              fromDate: values.fromDate,
              page: 0,
              size: 10,
              employeeName: values.employeeName,
              projectName: values.projectName,
              sortby: null
            })
          );
        }}
      >
        {({ values, errors, touched, setFieldValue, handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-wrap lg:flex-nowrap gap-5 my-5 items-center"
          >
            {/* Employee Dropdown */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <CustomDropdown
                value={
                  usersList?.response?.find((user) => user.id == values?.employee) || null
                }
                name="employee"
                handleChange={(selectedOption) => {
                  dispatch(setResetStateTimesheetById());
                  dispatch(requestProjectsById(selectedOption?.id));
                  setFieldValue("employee", selectedOption?.id);
                  setFieldValue("employeeName", `${selectedOption.firstName} ${selectedOption.lastName}`);
                  setFieldValue("fromDate", "");
                  setSelectedEmployeeId(selectedOption?.id);
                  // Reset sort state when employee changes
                  setSortBy('desc');
                }}
                customClasses="w-full text-left"
                placeholder="Select Employee"
                options={usersList?.response || []}
                handleGetOptionValue={(option) => option.id}
                handleGetOptionName={(option) => `${option.firstName} ${option.lastName}`}
              />
              {errors.employee && touched.employee ? (
                <p className="text-red-400 text-sm">{errors.employee}</p>
              ) : null}
            </div>

            {/* Project Dropdown */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <CustomDropdown
                value={
                  projectsList?.response?.find((project) => project.id == values?.project) ||
                  null
                }
                name="project"
                handleChange={(selectedOption) => {
                  setFieldValue("project", selectedOption?.id);
                  setFieldValue('projectName', selectedOption.projectName )
                  setFieldValue("fromDate", "");
                  // Reset sort state when project changes
                  setSortBy('desc');
                }}
                customClasses="w-full text-left h-10"
                placeholder="Select Project"
                options={projectsList?.response || []}
                handleGetOptionValue={(option) => option.id}
                handleGetOptionName={(option) => option.projectName}
                // isDisabled={!projectsList?.response?.length}
                isDisabled={!values.employee && !projectsList?.response?.length}
                className={`${
                  !projectsList?.response?.length && !values.employee? "cursor-not-allowed opacity-50" : ""
                }`}
              />
              {errors.project && touched.project ? (
                <p className="text-red-400">{errors.project}</p>
              ) : null}
            </div>

            {/* Date Picker */}
            <div className="lg:w-1/3 md:w-1/2 w-full">
              <MuiDatePicker
                label="From Date"
                name="fromDate"
                value={values?.fromDate ? moment(values?.fromDate) : null}
                onChange={(date) => {
                  setFieldValue("fromDate", moment(date).format("MM-DD-YYYY"));
                }}
                disabled={false}
                className="w-full h-10"
                maxDate={moment()}
              />
            </div>

            {/* Buttons */}
            <div className="lg:w-1/3 md:w-1/2 w-full flex gap-4">
              <button
                type="submit"
                className={`bg-primary text-white px-4 rounded-lg hover:bg-primaryDark h-10 flex-1 ${
                  !(values.employee && values.project)
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={!(values.employee && values.project)}
              >
                Submit
              </button>
              <button
                type="button"
                onClick={handleinvoice}
                className={`${
                  selectedRows.length > 0 ? "bg-primary" : "bg-gray-600"
                } text-white px-4 rounded-lg hover:bg-primaryDark h-10 flex-[1.5] min-w-[150px]`}
                disabled={!selectedRows.length > 0}
              >
                Generate Invoice
              </button>
            </div>
          </form>
        )}
      </Formik>

      {/* {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-[500px]">
            <h2 className="text-lg font-semibold mb-2">Enter Rate per Hour</h2>
            <input
              type="number"
              value={ratePerHour}
              onChange={(e) => setRatePerHour(e.target.value)}
              className="border p-2 w-full"
              placeholder="Enter rate"
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setRatePerHour("");
                }}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )} */}

      <ModalComponent
        show={modalOpen.open}
        classes={"w-1/3"}
        onClose={() => {
          setModalOpen({ open: false, id: "" });
          setReason("");
        }}
        title="Reason For Rejection"
      >
        <textarea
          type="text"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="border p-2 my-2 w-full"
        />
        <div className="flex justify-end mt-4">
          <button
            onClick={() => handleConfirmReject(modalOpen?.id)}
            className="bg-primary text-white px-4 py-2 rounded"
          >
            Confirm
          </button>
        </div>
      </ModalComponent>

   

      <div>
        <CustomDataTable
          columns={columns}
          data={TimeSheets?.response?.content || []}
          enableSearch={false}
          serverPagenation
          paginationTotalRows={TimeSheets?.response?.totalElements}
          handleChangePage={handlePageChange}
          handleRowsChange={handleRowsChange}
          conditionalRowStyles={conditionalRowStyles}
          onSelectedRowsChange={handleCheckboxChange}
          selectableRows={true}
          selectableRowDisabled={rowDisabledCriteria}
          clearSelectedRows={clearSelectedRows}
          fixedHeaderScrollHeight={"62vh"}
          isMultiSelect={false}
        />
      </div>
      {/* Details Modal */}
     <DetailsModal
     isOpen={isModalOpenView}
     onClose={() => setIsModalOpenView(false)}
     data={selectedRow}
     onDownload={downloadFile}
     isDownloading={DownloadFileByIdReducer?.loading}
   />
    </div>

     

  );
};

export default Hoc(AdminTimesheet);